/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputDisableTwoFactorRequest
 */
export interface InputDisableTwoFactorRequest {
    /**
     * 
     * @type {string}
     * @memberof InputDisableTwoFactorRequest
     */
    challenge: string;
    /**
     * 
     * @type {string}
     * @memberof InputDisableTwoFactorRequest
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof InputDisableTwoFactorRequest
     */
    credential?: string;
    /**
     * 
     * @type {string}
     * @memberof InputDisableTwoFactorRequest
     */
    method: InputDisableTwoFactorRequestMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof InputDisableTwoFactorRequest
     */
    verificationMethod: InputDisableTwoFactorRequestVerificationMethodEnum;
}


/**
 * @export
 */
export const InputDisableTwoFactorRequestMethodEnum = {
    Webauthn: 'webauthn',
    Totp: 'totp'
} as const;
export type InputDisableTwoFactorRequestMethodEnum = typeof InputDisableTwoFactorRequestMethodEnum[keyof typeof InputDisableTwoFactorRequestMethodEnum];

/**
 * @export
 */
export const InputDisableTwoFactorRequestVerificationMethodEnum = {
    Webauthn: 'webauthn',
    Totp: 'totp'
} as const;
export type InputDisableTwoFactorRequestVerificationMethodEnum = typeof InputDisableTwoFactorRequestVerificationMethodEnum[keyof typeof InputDisableTwoFactorRequestVerificationMethodEnum];


/**
 * Check if a given object implements the InputDisableTwoFactorRequest interface.
 */
export function instanceOfInputDisableTwoFactorRequest(value: object): boolean {
    if (!('challenge' in value)) return false;
    if (!('method' in value)) return false;
    if (!('verificationMethod' in value)) return false;
    return true;
}

export function InputDisableTwoFactorRequestFromJSON(json: any): InputDisableTwoFactorRequest {
    return InputDisableTwoFactorRequestFromJSONTyped(json, false);
}

export function InputDisableTwoFactorRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputDisableTwoFactorRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge': json['challenge'],
        'code': json['code'] == null ? undefined : json['code'],
        'credential': json['credential'] == null ? undefined : json['credential'],
        'method': json['method'],
        'verificationMethod': json['verificationMethod'],
    };
}

export function InputDisableTwoFactorRequestToJSON(value?: InputDisableTwoFactorRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'challenge': value['challenge'],
        'code': value['code'],
        'credential': value['credential'],
        'method': value['method'],
        'verificationMethod': value['verificationMethod'],
    };
}

